@if (isOpenSignal()) {
  <div
    class="tw:fixed tw:bottom-4 tw:right-4 tw:top-44 tw:min-[1080px]:top-32 tw:w-[400px] tw:z-10 tw:bg-white"
    data-test="assistant-panel"
  >
    @if (isAuthenticatedSignal()) {
      <gaia-chat
        data-test="ai-assistant-chat"
        auth-strategy="visma"
        #gaiaChat
        [attr.base-url]="baseUrl"
        [attr.lang]="languageCodeSignal()"
        [attr.profile-id]="profileId"
        [attr.visma-token]="accessTokenSignal()"
        (auth-failed)="onAuthFailed($event)"
        (close-requested)="close()"
      />
    } @else {
      <gaia-chat
        data-test="ai-assistant-chat"
        auth-strategy="visitor"
        #gaiaChat
        [attr.base-url]="baseUrl"
        [attr.lang]="languageCodeSignal()"
        [attr.profile-id]="profileId"
        (auth-failed)="onAuthFailed($event)"
        (close-requested)="close()"
      />
    }
  </div>
}
